import { loc } from '../common';

export default loc(
  7, 'CharredRuins1', ['Ashlands'],
  { type: 'misc',
    biomeArea: 7, quantity: 75, group: 'zigg', minApart: 256,
    terrainDelta: [0, 6], minAlt: -10, radius: [32, 12],
    items: [],
  },
  'CharredRuins_big',
);
